import { StoreAction } from '../../models/rootState.model';
// tslint:disable: class-name

// Types
export const INTERNET_ACTION_TYPES = {
  INTERNET_INIT: '[Api] -Verify initial connection-',
  INTERNET_OFFLINE: '[Api] -Internet is offline-',
  INTERNET_ONLINE: '[Api] - Internet is online-',
};

export class Action_Internet_Init implements StoreAction {
  readonly type = INTERNET_ACTION_TYPES.INTERNET_INIT;
}

export class Action_Internet_Offline implements StoreAction {
  readonly type = INTERNET_ACTION_TYPES.INTERNET_OFFLINE;
}

export class Action_Internet_Online implements StoreAction {
  readonly type = INTERNET_ACTION_TYPES.INTERNET_ONLINE;
}


// Type
export type InternetAction =
  | Action_Internet_Init
  | Action_Internet_Offline
  | Action_Internet_Online;
